import { render, staticRenderFns } from "./MenuItemOptions.vue?vue&type=template&id=a99279fa&scoped=true&"
import script from "./MenuItemOptions.vue?vue&type=script&lang=js&"
export * from "./MenuItemOptions.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemOptions.vue?vue&type=style&index=0&id=a99279fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99279fa",
  null
  
)

export default component.exports